import React, { useEffect, useState } from "react";
import api from "../api/api";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { alphaNumericPattern, emailrgx } from "../assets/constant";
import { useAuth } from "../context/AuthContext";
import PropTypes from 'prop-types';
import { data } from "jquery";
import { titles } from "../assets/titles";
import { useTranslation } from "react-i18next";
import { schema } from "../schema/schemaEditEmployer";
const EditEmployer = ({onRefresh , selectedEmployer}) => {

	const {user} = useAuth();
	const { t } = useTranslation();
	

	const {
		reset,
		handleSubmit,
		control,
		register,
		setError,
		clearErrors,
        setValue,
		formState: { errors },
	} = useForm({
		resolver: yupResolver(schema(t)),
		//defaultValues: inputValues,
	});

	const [loadingSendInv,setloadingSendInv] = useState(false)
	const [successinvite,setsuccessinvite] = useState(null)

	const onSubmit = async(data) => {
		clearErrors();
		setsuccessinvite(null)
		let typeurl;
		typeurl=`/employer-management/${selectedEmployer?.id}/profile/`

		if (loadingSendInv) return;
		setloadingSendInv(true);
			
		try {
			const response = await api.patch(typeurl, data); 

			
			console.log("Response Code:", response.status);
			console.log("Form submitted successfully!");

			reset();
			setsuccessinvite(response.data['result'])

			if (onRefresh) onRefresh();

			document.querySelector('#edit_employer .btn-close')?.click();
		} catch (error) {
			let  errorMessage = ""
			// Extract response code if available
			const responseCode = error.response ? error.response.status : "Unknown";
			console.log("Response Code:", responseCode);
			if (error?.response?.data) {	
				Object.entries(error.response.data).forEach(([key, values]) => {
					//if (key !== "token" && key !== "agency") {
						console.log(key, values);
						errorMessage += `${values}\n`;
					//}
				});
			}
						
			// If no specific error was found, provide a default message
			if (!errorMessage) {
				errorMessage = "An unknown error occurred.";
			}
			
			// Set the error message in React Hook Form
			setError("root", { type: "server", message: errorMessage });
		} finally {
				setloadingSendInv(false);
		}
	}
	useEffect(()=>{		
		clearErrors();

        // Set form values when selectedEmployer changes
        if (selectedEmployer) {
            setValue("title", selectedEmployer.title || "");
            setValue("name", selectedEmployer.name || "");
            setValue("phone", selectedEmployer.phone || "");
            setValue("email", selectedEmployer.email || "");
        }
	},[selectedEmployer, setValue])

	return (
			<div className="modal custom-modal modal-lg fade" id="edit_employer" role="dialog">
				<div className="modal-dialog modal-dialog-centered modal-md">
					<div className="modal-content">
						<div className="modal-header border-0 pb-0">
							<div className="form-header modal-header-title text-start mb-0">
								<h4 className="mb-0">{t("Edit Employer")}</h4>
							</div>
							<button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
						</div>
						<form  onSubmit={handleSubmit(onSubmit)}>
							<div className="modal-body">
								<div className="row">
									<div className="col-md-12">
										<div className="card-body">
											<div className="form-groups-item">
												<div className="row">
                                                    <div className="col-md-12">
                                                        <div className="input-block mb-3">
                                                            <label htmlFor="title" className="form-label">{t("Title")}</label>
                                                            <select
                                                                className="form-select"
                                                                id="title"
                                                                {...register("title")}
                                                            >
                                                                <option value="">{t("Select title")}</option>
                                                                {titles.map((title) => (
                                                                <option key={title} value={title}>
                                                                    {title}
                                                                </option>
                                                                ))}
                                                            </select>
                                                            <p className="text-danger">{errors?.title?.message}</p>
                                                        </div>
                                                        <div className="input-block mb-3">
                                                            <label>Name</label>
                                                            <input type="name"
                                                                {...register("name")}
                                                                className="form-control" 
                                                                
                                                            />
                                                            <p className={"text-danger"}>{errors?.name?.message}</p>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="input-block mb-3">
                                                            <label>Phone</label>
                                                            <input type="phone"
                                                                {...register("phone")}
                                                                className="form-control" 
                                                                 
                                                            />
                                                            <p className={"text-danger"}>{errors?.phone?.message}</p>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="input-block mb-3">
                                                            <label>{t("Email")}</label>
                                                            <input type="email"
                                                                {...register("email")}
                                                                className="form-control"
                                                               
                                                            />
                                                            <p className={"text-danger"}>{errors?.email?.message}</p>
                                                        </div>
                                                    </div>
                                                </div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="modal-footer">
								{/* <small  style={{color:"green"}}> {successinvite && <p>Your invitation was successfully delivered to <b>{successinvite}</b></p>}</small> */}
								<small  style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
								<div className="d-flex justify-content-end w-100 mt-2"> 
									<button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
									<button type="submit"  className="btn btn-primary ">
										{t("Edit Employer")}
										{loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
									</button>
								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
    ); 
};

EditEmployer.propTypes = {
	onRefresh: PropTypes.func.isRequired,
    selectedEmployer: PropTypes.object.isRequired
};

export default EditEmployer;
